<div class="shell"
     [class.shell--mobile-open]="mobileSidebarOpen()"
     [class.shell--sidebar-collapsed]="sidebarCollapsed()"
     [class.shell--service-horizontal]="portal().code === 'SERVICE_DESK'">

  <a class="skip-link" href="#main-content">Ir al contenido principal</a>

  <aside class="sidebar" aria-label="Navegacion principal">
    <div class="sidebar-brand">
      <a [routerLink]="portal().route" aria-label="DeskPlus One">
        <img src="/assets/brand/deskplus-one-horizontal.svg" alt="DeskPlus One">
      </a>
      <button class="sidebar-close" type="button" aria-label="Cerrar navegacion" (click)="toggleSidebar()">&times;</button>
    </div>

    <div class="portal-card">
      <button type="button" (click)="togglePortalMenu()" [attr.aria-expanded]="portalMenuOpen()">
        <span class="portal-card__icon"><app-shell-icon name="users"></app-shell-icon></span>
        <span class="portal-card__copy">
          <small>Portal actual</small>
          <strong>{{ portal().label }}</strong>
          <em>NIOTECH DEMO S.A.</em>
        </span>
        <b class="portal-card__chevron" aria-hidden="true">&#8964;</b>
      </button>

      @if (portalMenuOpen()) {
        <section class="portal-switcher">
          <header>
            <small>ESPACIOS AUTORIZADOS</small>
            <strong>Cambiar de portal</strong>
            <p>Accede solo a los espacios habilitados para tu cuenta.</p>
          </header>

          @for (destination of portalOptions(); track destination.routePath) {
            <button
              type="button"
              class="portal-option"
              [class.portal-option--active]="destination.routePath === portal().route"
              (click)="switchPortal(destination)">
              <span class="portal-option__icon"><app-shell-icon [name]="destination.portalCode || 'portal'"></app-shell-icon></span>
              <span>
                <strong>{{ destination.displayName || destination.portalCode }}</strong>
                <small>{{ destination.isPreferredPortal ? 'Portal preferido' : 'Portal autorizado' }}</small>
              </span>
              @if (destination.routePath === portal().route) { <b>&#10003;</b> }
            </button>
          }

          <footer>Los permisos siempre son validados por DeskPlus One.</footer>
        </section>
      }
    </div>

    <nav class="nav-scroll" aria-label="Secciones">
      @for (group of visibleNavigationGroups(); track $index; let groupIndex = $index) {
        <section class="nav-group">
          @if (group.label) {
            <button class="nav-group__heading" type="button" (click)="toggleGroup(groupIndex)">
              <span>{{ group.label }}</span>
              <span [class.rotated]="!isGroupCollapsed(groupIndex)">&#8964;</span>
            </button>
          }

          @if (!isGroupCollapsed(groupIndex)) {
            @for (item of group.items; track item.route) {
              <a
                class="nav-item"
                [routerLink]="item.route"
                routerLinkActive="nav-item--active"
                [routerLinkActiveOptions]="{ exact: item.exact ?? false }"
                [attr.title]="sidebarCollapsed() ? item.label : null"
                (click)="mobileSidebarOpen.set(false)">
                <span class="nav-icon"><app-shell-icon [name]="item.route + ' ' + item.label"></app-shell-icon></span>
                <span class="nav-label">{{ item.label }}</span>
                @if (item.label === 'Notificaciones' && unreadNotifications() > 0) {
                  <span class="nav-badge">{{ unreadNotifications() }}</span>
                } @else if (item.badge) { <span class="nav-badge">{{ item.badge }}</span> }
              </a>
            }
          }
        </section>
      }

      @if (portal().code === 'CUSTOMER_ADMIN') {
        <section class="resource-nav" aria-label="Recursos">
          <div class="resource-nav__heading">
            <span>RECURSOS</span>
          </div>

          <a
            class="resource-nav__item"
            routerLink="/app/admin/knowledge"
            routerLinkActive="resource-nav__item--active"
            title="Manuales e instructivos">
            <span class="resource-nav__icon"><app-shell-icon name="knowledge"></app-shell-icon></span>
            <span class="resource-nav__label">Manuales e instructivos</span>
          </a>

          <a
            class="resource-nav__item"
            routerLink="/app/admin/policies"
            routerLinkActive="resource-nav__item--active"
            title="Normas y politicas">
            <span class="resource-nav__icon"><app-shell-icon name="shield"></app-shell-icon></span>
            <span class="resource-nav__label">Normas y politicas</span>
          </a>
        </section>
      }
    </nav>

    <div class="sidebar-version">
      <span>DeskPlus One</span>
      <strong>v1.0.0</strong>
    </div>
  </aside>

  @if (mobileSidebarOpen()) {
    <button class="mobile-backdrop" type="button" aria-label="Cerrar navegacion" (click)="toggleSidebar()"></button>
  }

  <section class="workspace">
    <header class="topbar">
      @if (portal().code === 'SERVICE_DESK') {
        <a class="service-topbar-brand" routerLink="/app/services" aria-label="DeskPlus One - Portal de Servicios">
          <img src="/assets/brand/deskplus-one-horizontal.svg" alt="DeskPlus One">
        </a>
      }
      <button
        class="menu-button"
        type="button"
        [attr.aria-label]="sidebarCollapsed() ? 'Expandir navegacion' : 'Contraer navegacion'"
        (click)="toggleSidebar()">
        <span></span><span></span><span></span>
      </button>

      <button class="search-trigger" type="button" (click)="openSearch()">
        <app-shell-icon name="search"></app-shell-icon>
        <span>Buscar en toda la plataforma...</span>
        <kbd>Ctrl</kbd><kbd>K</kbd>
      </button>

      <a class="create-button" [routerLink]="portal().primaryAction.route">
        <app-shell-icon [name]="portal().primaryAction.icon"></app-shell-icon>
        <span>{{ portal().primaryAction.label }}</span>
      </a>

      <div class="topbar-actions">
        <button
          class="icon-button notification-button"
          type="button"
          title="Notificaciones"
          aria-label="Notificaciones"
          (click)="toggleNotifications()"
          [attr.aria-expanded]="notificationMenuOpen()">
          <span class="bell-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" role="presentation">
              <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9"></path>
              <path d="M10 21h4"></path>
            </svg>
          </span>
          @if (unreadNotifications() > 0) {
            <span class="dot-badge">{{ unreadNotifications() }}</span>
          }
        </button>

        <div class="language-menu">
          <button class="language-trigger" type="button" (click)="toggleLanguageMenu()" [attr.aria-expanded]="languageMenuOpen()">
            <span class="language-flag" [class.language-flag--en]="i18n.locale() === 'en'">
              <i></i><b>{{ i18n.locale() === 'es' ? 'ES' : 'EN' }}</b>
            </span>
            <span>{{ i18n.locale() === 'es' ? 'Espanol' : 'English' }}</span>
            <b>&#8964;</b>
          </button>

          @if (languageMenuOpen()) {
            <section class="language-popover">
              <button type="button" [class.selected]="i18n.locale() === 'es'" (click)="setLocale('es')">
                <span class="language-option language-option--es"><i></i><b>ES</b></span>
                <strong>Espanol</strong>
                <b>{{ i18n.locale() === 'es' ? '&#10003;' : '' }}</b>
              </button>
              <button type="button" [class.selected]="i18n.locale() === 'en'" (click)="setLocale('en')">
                <span class="language-option language-option--en"><i></i><b>EN</b></span>
                <strong>English</strong>
                <b>{{ i18n.locale() === 'en' ? '&#10003;' : '' }}</b>
              </button>
            </section>
          }
        </div>
        @if (portal().code === 'SERVICE_DESK') {
          <div class="service-portal-switcher">
            <button class="service-portal-trigger" type="button" (click)="togglePortalMenu()" [attr.aria-expanded]="portalMenuOpen()">
              <app-shell-icon name="portal"></app-shell-icon>
              <span>{{ portal().label }}</span>
              <b>&#8964;</b>
            </button>

            @if (portalMenuOpen()) {
              <section class="service-portal-popover" aria-label="Cambiar de portal">
                <header>
                  <small>ESPACIOS AUTORIZADOS</small>
                  <strong>Cambiar de portal</strong>
                </header>

                @for (destination of portalOptions(); track destination.routePath) {
                  <button type="button" [class.active]="destination.routePath === portal().route" (click)="switchPortal(destination)">
                    <app-shell-icon [name]="destination.portalCode || 'portal'"></app-shell-icon>
                    <span>
                      <strong>{{ destination.displayName || destination.portalCode }}</strong>
                      <small>{{ destination.isPreferredPortal ? 'Portal preferido' : 'Portal autorizado' }}</small>
                    </span>
                    @if (destination.routePath === portal().route) { <b>&#10003;</b> }
                  </button>
                }
              </section>
            }
          </div>
        }

        <button class="icon-button" type="button" title="Pantalla completa" aria-label="Pantalla completa" (click)="toggleFullscreen()">
          <span class="fullscreen-glyph">{{ fullscreen() ? '&#10006;' : '&#9974;' }}</span>
        </button>

        <button class="user-trigger user-trigger--identity" type="button" (click)="toggleUserMenu()" [attr.aria-expanded]="userMenuOpen()">
          @if (profilePhotoUrl()) {
            <img class="avatar avatar--photo" [src]="profilePhotoUrl()!" alt="">
          } @else {
            <span class="avatar">{{ session.identity.initials }}</span>
          }
          <span class="user-trigger__copy">
            <strong>{{ session.identity.displayName }}</strong>
            <small>{{ session.identity.email || 'Cuenta DeskPlus One' }}</small>
          </span>
          <b>&#8964;</b>
        </button>
      </div>
    </header>
    @if (portal().code === 'SERVICE_DESK') {
      <nav class="service-horizontal-nav" aria-label="Navegacion del Portal de Servicios">
        <a routerLink="/app/services" routerLinkActive="service-nav-active" [routerLinkActiveOptions]="{ exact: true }"><app-shell-icon name="home"></app-shell-icon><span>Inicio</span></a>
        <a routerLink="/app/services/catalog" routerLinkActive="service-nav-active"><app-shell-icon name="catalog"></app-shell-icon><span>Catalogo de servicios</span></a>
        <a routerLink="/app/services/requests" routerLinkActive="service-nav-active"><app-shell-icon name="requests"></app-shell-icon><span>Mis solicitudes</span></a>
        <a routerLink="/app/services/knowledge" routerLinkActive="service-nav-active"><app-shell-icon name="knowledge"></app-shell-icon><span>Conocimiento</span></a>

        <details class="service-nav-resources">
          <summary><app-shell-icon name="resources"></app-shell-icon><span>Recursos</span><b>&#8964;</b></summary>
          <section class="service-resources-menu">
            <a routerLink="/app/services/knowledge"><app-shell-icon name="knowledge"></app-shell-icon><span>Base de conocimiento</span></a>
            <a routerLink="/app/services/documents"><app-shell-icon name="documents"></app-shell-icon><span>Centro documental</span></a>
            <a routerLink="/app/services/procedures"><app-shell-icon name="procedures"></app-shell-icon><span>Procedimientos</span></a>
            <a routerLink="/app/services/policies"><app-shell-icon name="policies"></app-shell-icon><span>Normas ISO / ITIL</span></a>
            <a routerLink="/app/services/tutorials"><app-shell-icon name="tutorials"></app-shell-icon><span>Videos y tutoriales</span></a>
            <a routerLink="/app/services/faq"><app-shell-icon name="faq"></app-shell-icon><span>Preguntas frecuentes</span></a>
          </section>
        </details>

        <a routerLink="/app/services/projects" routerLinkActive="service-nav-active"><app-shell-icon name="projects"></app-shell-icon><span>Proyectos</span></a>
        <a routerLink="/app/services/assets" routerLinkActive="service-nav-active"><app-shell-icon name="assets"></app-shell-icon><span>Activos</span></a>
        <a routerLink="/app/services/contracts" routerLinkActive="service-nav-active"><app-shell-icon name="contracts"></app-shell-icon><span>Contratos</span></a>
        <a routerLink="/app/services/calendar" routerLinkActive="service-nav-active"><app-shell-icon name="calendar"></app-shell-icon><span>Calendario</span></a>
        <a routerLink="/app/services/surveys" routerLinkActive="service-nav-active"><app-shell-icon name="surveys"></app-shell-icon><span>Encuestas</span></a>
      </nav>
    }

    <div class="breadcrumb-bar" aria-label="Miga de pan">
      <div>
        <a class="breadcrumb-home" [routerLink]="portal().route" [attr.aria-label]="'Inicio de ' + portal().label">
          <app-shell-icon name="home"></app-shell-icon>
        </a>
        <span>&rsaquo;</span>
        <a [routerLink]="portal().route">{{ portal().label }}</a>
        <span>&rsaquo;</span>
        <strong>{{ currentPageLabel() }}</strong>
      </div>
    </div>

    @if (notificationMenuOpen()) {
      <section class="notification-popover" aria-label="Notificaciones">
        <header>
          <div><strong>Notificaciones</strong><small>Actividad de tu espacio de trabajo</small></div>
          @if (unreadNotifications() > 0) { <button type="button" (click)="markNotificationsRead()">Marcar como leídas</button> }
        </header>
        @if (notificationsLoading()) {
          <div class="notification-empty"><strong>Cargando alertas…</strong></div>
        } @else if (notificationAlerts().length) {
          <div class="notification-module-heading"><span>Service Management</span><b>{{ notificationAlerts().length }}</b></div>
          <div class="notification-list">
            @for (alert of notificationAlerts(); track alert.id) {
              <button type="button" class="notification-item" [class.unread]="isNotificationUnread(alert.id)" (click)="openNotification(alert)">
                <span class="notification-severity" [attr.data-status]="alert.severity">{{ alert.severity === 'CRITICAL' ? '!' : '⌛' }}</span>
                <span><strong>{{ alert.title }}</strong><small>{{ alert.description }}</small><small>{{ notificationDate(alert.occurredAt) }}</small></span>
              </button>
            }
          </div>
        } @else {
        <div class="notification-empty">
          <span class="notification-empty__icon">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9"></path>
              <path d="M10 21h4"></path>
            </svg>
          </span>
          <strong>Todo esta al dia</strong>
          <p>Las alertas reales de solicitudes, aprobaciones, SLA, proyectos, seguridad y automatizaciones apareceran aqui.</p>
        </div>
        }
        <button type="button" class="notification-center-link" (click)="openNotificationCenter()">Ver centro de notificaciones →</button>
      </section>
    }

    @if (userMenuOpen()) {
      <section class="user-popover--rich">
        <header>
          @if (profilePhotoUrl()) {
            <img class="avatar avatar--photo avatar--large" [src]="profilePhotoUrl()!" alt="">
          } @else {
            <span class="avatar avatar--large">{{ session.identity.initials }}</span>
          }
          <div>
            <strong>{{ session.identity.displayName }}</strong>
            <span>{{ session.identity.email || 'Sesion activa' }}</span>
          </div>
        </header>

        <div class="user-menu-list">
          <button type="button" (click)="openProfile()">
            <app-shell-icon name="users"></app-shell-icon>
            <span><strong>Mi perfil</strong><small>Datos personales y fotografia</small></span>
          </button>
          <button type="button" (click)="openPersonalSettings()">
            <app-shell-icon name="settings"></app-shell-icon>
            <span><strong>Preferencias de usuario</strong><small>Idioma, tema y experiencia personal</small></span>
          </button>
          <button type="button" (click)="openSecuritySessions()">
            <app-shell-icon name="shield"></app-shell-icon>
            <span><strong>Seguridad y sesiones</strong><small>Dispositivos, sesiones y acceso</small></span>
          </button>
          <button type="button" (click)="lockSession()">
            <app-shell-icon name="lock"></app-shell-icon>
            <span><strong>Bloquear pantalla</strong><small>Protege temporalmente tu espacio</small></span>
          </button>
        </div>

        <button class="logout-button" type="button" (click)="logout()">
          <span>&#9211;</span><strong>Cerrar sesion</strong>
        </button>
      </section>
    }

    @if (preferencesOpen()) {
      <section class="preferences-popover">
        <header>
          <div><small>DESKPLUS ONE</small><strong>Preferencias de usuario</strong></div>
          <button type="button" (click)="togglePreferences()">&times;</button>
        </header>
        <label>{{ i18n.t('shell.appearance') }}</label>
        <div class="segmented">
          <button type="button" [class.selected]="preferences.theme() === 'light'" (click)="setTheme('light')">Claro</button>
          <button type="button" [class.selected]="preferences.theme() === 'dark'" (click)="setTheme('dark')">Oscuro</button>
        </div>
        <label>{{ i18n.t('shell.accent') }}</label>
        <div class="accent-list">
          <button class="accent blue" type="button" (click)="setAccent('blue')" aria-label="Azul"></button>
          <button class="accent cyan" type="button" (click)="setAccent('cyan')" aria-label="Cian"></button>
          <button class="accent violet" type="button" (click)="setAccent('violet')" aria-label="Violeta"></button>
          <button class="accent teal" type="button" (click)="setAccent('teal')" aria-label="Verde azulado"></button>
        </div>
      </section>
    }

    <main id="main-content" class="main-content" tabindex="-1">
      <router-outlet></router-outlet>
    </main>

    <footer class="app-footer">
      <div class="footer-brand">
        <strong>NIOTECH</strong>
        <small>SISTEMAS DE SOPORTE TECNICO</small>
      </div>
      <div class="footer-copy">
        <strong>Plataforma desarrollada por NIOTECH SOLUTIONS S.A.</strong>
        <span>&copy; 2026 NIOTECH SOLUTIONS S.A. Todos los derechos reservados.</span>
      </div>
      <div class="footer-tagline">Tecnologia que impulsa tu organizacion.</div>
    </footer>
  </section>

  @if (searchOpen()) {
    <div class="search-overlay" role="dialog" aria-modal="true">
      <button class="search-backdrop" type="button" (click)="closeSearch()"></button>
      <section class="search-dialog">
        <header>
          <img src="/assets/brand/deskplus-one-isotype.svg" alt="">
          <div><small>DESKPLUS SEARCH + AI</small><strong>{{ i18n.t('search.title') }}</strong></div>
          <button type="button" (click)="closeSearch()">&times;</button>
        </header>
        <div class="global-search-box">
          <app-shell-icon name="search"></app-shell-icon>
          <input id="deskplus-global-search" type="search" [placeholder]="i18n.t('search.placeholder')" [value]="searchQuery()" (input)="updateSearch($any($event.target).value)">
          <kbd>ESC</kbd>
        </div>
        <div class="ask-deskplus-card">
          <span>&#10022;</span>
          <div><strong>{{ i18n.t('shell.askAi') }}</strong><p>{{ i18n.t('search.aiHint') }}</p></div>
          <span>Foundation</span>
        </div>
        <div class="search-results">
          <small>{{ i18n.t('search.navigation') }}</small>
          @if (searchResults().length) {
            @for (item of searchResults(); track item.route) {
              <button type="button" (click)="navigateFromSearch(item.route)">
                <app-shell-icon [name]="item.route + item.label"></app-shell-icon>
                <span>{{ item.label }}</span><span>&rarr;</span>
              </button>
            }
          } @else {
            <p>{{ i18n.t('search.noResults') }}</p>
          }
        </div>
      </section>
    </div>
  }
</div>
